import { render, staticRenderFns } from "./CarAccordion.vue?vue&type=template&id=73507918"
import script from "./CarAccordion.vue?vue&type=script&lang=js"
export * from "./CarAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports